// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Settings-pageTitle-TIMdL {
    font-size: 22px;
    font-weight: 700;
    color: #1F2733;
    margin: 0 0 18px;
    font-family: 'Poppins', sans-serif;
}

.Settings-settingCard-ciVxt {
    background: #fff;
    border: 1px solid #ECECEC;
    border-radius: 14px;
    padding: 18px 22px;
    margin-bottom: 16px;
}

.Settings-themeSelector-Ljxn5 {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    gap: 10px;
    -ms-flex-wrap: wrap;
        flex-wrap: wrap;
    margin-top: 6px;
}

.Settings-themePill-DKkbZ {
    padding: 8px 18px;
    border-radius: 999px;
    border: 1px solid #D9D9D9;
    background: #fff;
    color: #1F2733;
    font-weight: 600;
    cursor: pointer;
    -webkit-transition: all .15s ease;
    transition: all .15s ease;
}

.Settings-themePillActive-EmKuK {
    border-color: #D32F2F;
    background: #FFF6F4;
    color: #D32F2F;
}

.Settings-linkRow-j15FK {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    -webkit-box-pack: justify;
        -ms-flex-pack: justify;
            justify-content: space-between;
    padding: 18px 22px;
    border: 1px solid #ECECEC;
    border-radius: 14px;
    margin-bottom: 16px;
    background: #fff;
    cursor: pointer;
    text-decoration: none;
}

.Settings-linkRow-j15FK:hover {
    border-color: #D32F2F;
}

.Settings-linkRowLabel-Azs0y {
    font-size: 15px;
    font-weight: 600;
    color: #1F2733;
}

.Settings-linkRowChevron-pL_kd {
    font-size: 22px;
    line-height: 1;
    color: #D32F2F;
    font-weight: 700;
}
`, "",{"version":3,"sources":["webpack://./src/routes/settings/Settings.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,gBAAgB;IAChB,kCAAkC;AACtC;;AAEA;IACI,gBAAgB;IAChB,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,SAAS;IACT,mBAAe;QAAf,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,oBAAoB;IACpB,yBAAyB;IACzB,gBAAgB;IAChB,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,iCAAyB;IAAzB,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,yBAA8B;QAA9B,sBAA8B;YAA9B,8BAA8B;IAC9B,kBAAkB;IAClB,yBAAyB;IACzB,mBAAmB;IACnB,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,cAAc;IACd,gBAAgB;AACpB","sourcesContent":[".pageTitle {\n    font-size: 22px;\n    font-weight: 700;\n    color: #1F2733;\n    margin: 0 0 18px;\n    font-family: 'Poppins', sans-serif;\n}\n\n.settingCard {\n    background: #fff;\n    border: 1px solid #ECECEC;\n    border-radius: 14px;\n    padding: 18px 22px;\n    margin-bottom: 16px;\n}\n\n.themeSelector {\n    display: flex;\n    gap: 10px;\n    flex-wrap: wrap;\n    margin-top: 6px;\n}\n\n.themePill {\n    padding: 8px 18px;\n    border-radius: 999px;\n    border: 1px solid #D9D9D9;\n    background: #fff;\n    color: #1F2733;\n    font-weight: 600;\n    cursor: pointer;\n    transition: all .15s ease;\n}\n\n.themePillActive {\n    border-color: #D32F2F;\n    background: #FFF6F4;\n    color: #D32F2F;\n}\n\n.linkRow {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 18px 22px;\n    border: 1px solid #ECECEC;\n    border-radius: 14px;\n    margin-bottom: 16px;\n    background: #fff;\n    cursor: pointer;\n    text-decoration: none;\n}\n\n.linkRow:hover {\n    border-color: #D32F2F;\n}\n\n.linkRowLabel {\n    font-size: 15px;\n    font-weight: 600;\n    color: #1F2733;\n}\n\n.linkRowChevron {\n    font-size: 22px;\n    line-height: 1;\n    color: #D32F2F;\n    font-weight: 700;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pageTitle": `Settings-pageTitle-TIMdL`,
	"settingCard": `Settings-settingCard-ciVxt`,
	"themeSelector": `Settings-themeSelector-Ljxn5`,
	"themePill": `Settings-themePill-DKkbZ`,
	"themePillActive": `Settings-themePillActive-EmKuK`,
	"linkRow": `Settings-linkRow-j15FK`,
	"linkRowLabel": `Settings-linkRowLabel-Azs0y`,
	"linkRowChevron": `Settings-linkRowChevron-pL_kd`
};
module.exports = ___CSS_LOADER_EXPORT___;
